export default __webpack_public_path__ + "static/media/maxdome_more_info_small.hevc.0f22889d.mp4";